import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import React from "react";

const introText = `SSG랜더스 APP 회원일 경우 홈경기 관람 후 티켓 인증을 통해 직관 기록을 남기실 수 있습니다.
직관 기록은 경기당 1회 가능합니다.
[직관 기록 이용 방법]
1) SSG랜더스 APP 설치 후 회원가입
2) APP > MY > 직관 기록 메뉴 확인
3) 당일 경기 티켓 인증 후 직관 기록 등록
자세한 사항은 SSG랜더스 APP을 확인해 주세요.`;

const common = [
  {
    title: "자동 직관 기록 방법",
    content:
      "입장 티켓 검표 시, SSG랜더스 APP에서 예매한 계정에 자동 직관 기록 처리 됩니다.\n-SSG랜더스 APP 예매 건에 한 해 적용됩니다.\n-직관 기록은 반드시 경기 당일 적립 여부 확인이 필요합니다.\n-자동 직관 기록 불가 시 수동 직관 기록을 이용하여 주시기 바랍니다.",
  },
  {
    title: "수동 직관 기록 방법",
    content:
      "자동 직관 기록이 되지 않는 경우, 수동 직관 기록 가능합니다.\n수동 직관 기록 방법\n- SSG랜더스 APP > MY > 직관 기록 > 수동 직관 기록 > 티켓 QR 코드 or 티켓 번호 입력\n(티켓번호 : 알파벳 T+숫자 13자리)\n\n*가능 시간 : 경기 시작 3시간 전~경기 종료 시\n- 직관 기록은 경기당 1회 가능합니다.\n- 수동 직관 기록 등록이 어려운 경우, 경기 당일 랜더스센터를 방문해 주시기 바랍니다.\n성함, 연락처, SSG랜더스 APP ID를 전달해 주시고 당일 경기 티켓을 제시해 주시면 직관 기록 반영이 가능합니다.\n(랜더스센터 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞))",
  },
  {
    title: "자동 직관 기록이 등록 되지 않았어요.\n직관 기록이 등록되지 않았어요.",
    content:
      "자동 직관 기록 요건을 충족하지 않는 경우(예시 : 타인이 구매한 티켓으로 동반 입장, 현장 구매 후 입장 등) 수동 직관기록이 필요합니다.\n\n수동 직관 기록 방법\n- SSG랜더스 APP > MY > 직관 기록 > 수동 직관 기록 > 티켓 QR 코드 or 티켓 번호 입력\n(티켓번호 : 알파벳 T+숫자 13자리)\n\n*가능 시간 : 경기 시작 3시간 전~경기 종료 시\n- 직관 기록은 경기당 1회 가능합니다.\n- 수동 직관 기록 등록이 어려운 경우, 경기 당일 랜더스센터를 방문해 주시기 바랍니다.\n성함, 연락처, SSG랜더스 APP ID를 전달해 주시고 당일 경기 티켓을 제시해 주시면 직관 기록 반영이 가능합니다.\n(랜더스센터 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞))",
  },
];

export const AccordionItemComponent = ({
  item,
  index,
}) => {
  return (
    <AccordionItem
      key={index}
      itemKey={index}
      className="mb-2"
      header={({state}) => 
        <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
          <span
            className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
          >
            Q
          </span>
          <span className="whitespace-pre-line">{item.title}</span>
        </div>
      }
    >
      {({state}) => 
        <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
          <div className="font-medium text-gray-950 whitespace-pre-line">{item.content}</div>
        </div>
      } 
    </AccordionItem>
  );
}


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

const CheckinPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };


  return (
    <section className="p-hasHeader">
      <Header title="직관기록" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 whitespace-pre-line">
        {introText}
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("체크인_전화상담")}
        />
      </div>
    </section>
  );
};

export default CheckinPage;
